module.exports = __webpack_public_path__ + "906af5e9dc4f6bd7eba883e59305ad1a.MP3";